"use client";

import { useEffect } from "react";
import useAuthStore from "@auth/store/useAuthStore";
import { getTenantFromSubdomain } from "@config/axios.setup";
import { createReverbConnection } from "@config/reverb";
import type { PermissionsUserUpdate } from "@auth/store/useAuthStore";

export function ReverbPermissions() {
  const token = useAuthStore((state) => state.token);
  const userId = useAuthStore((state) => state.user?.id);
  const tenant = getTenantFromSubdomain();

  useEffect(() => {
    if (!token || userId == null || !tenant) return;
    const echo = createReverbConnection(token, tenant);
    if (!echo) return;
    const channel = `${tenant}.5.permissions.user.${userId}`;

    const subscription = echo.private(channel);
    subscription.listen(".UserPermissionsUpdated", (response: {
      success?: boolean;
      user?: PermissionsUserUpdate;
    }) => {
      const updated = response?.user;
      if (response?.success !== true || !updated || !updated.permissions ||
        typeof updated.permissions !== "object" || Array.isArray(updated.permissions)) return;
      // Ignore queued events from a previous session or connection.
      const state = useAuthStore.getState();
      if (state.token !== token || getTenantFromSubdomain() !== tenant) return;
      if (!state.user || String(state.user.id) !== String(updated.id)) return;
      state.updatePermissions(updated);
    });

    return () => {
      echo.leave(channel);
      echo.disconnect();
    };
  }, [token, userId, tenant]);

  return null;
}
